import React from 'react';
import { getOrganization } from '../../../Helpers/AuthHelper';
import {
  NewContactIcon,
  NewItemIcon,
  NewOrganizationIcon,
} from '../../../Assets/Navigation/NavigationIcons';
import { seebizCloudUrl } from '../../../Helpers/UrlHelper';
import { t } from 'i18next';

export default function InitialDashboardScreen() {
  const seebizUrl = seebizCloudUrl();
  return (
    <div className="intital_screen float-left w-100">
      <div className="left_section">
        <div className="onboarding-welcome--title">
          <p>{t('Dashboard.seebiz_team')}</p>
          <p>{t('Dashboard.welcome_ims')}</p>
        </div>
        <div className="our_goal">
          <h2>{t('Dashboard.our_goal')}</h2>
        </div>

        <div className="listing_section">
          <ul>
            <li>
              <span>
                <a href={`/organization/edit?id=${getOrganization()}`}>
                  <NewOrganizationIcon />
                  {t('Dashboard.update_org')}
                </a>
              </span>
            </li>
            <li>
              <span>
                <a href="/contacts/import">
                  <NewContactIcon />
                  {t('Dashboard.add_contact')}
                </a>
              </span>
            </li>
            <li className="last">
              <span>
                <a href="/items/import">
                  <NewItemIcon />
                  {t('Dashboard.using_csv')}
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="right_section">
        <div className="information_section">
          <div className="information_section_title">
            <h1>{t('Dashboard.using_csv')}</h1>
            <p>
              {t('Dashboard.expect_ims')}
              {' '}
              <a
                href={`https://www.${seebizUrl}/inventory/contact-us/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Dashboard.help_section')}
              </a>
              {t('Dashboard.any_queries')}
              {' '}
              <a
                href={`https://www.${seebizUrl}/inventory/contact-us/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Dashboard.get_in_touch')}
              </a>
              {' '}
              {t('Dashboard.with_us')}
            </p>
          </div>
        </div>

        <div className="video_section">
          <div className="video_section_inner">
            <h3>{t('Dashboard.analyzing_summary')}</h3>
            <iframe
              width="100%"
              height="445"
              src="https://www.youtube.com/embed/GP-egmkc074"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
